import { Component, OnInit } from '@angular/core';
import { EmployeesDetailsComponent } from '../../employees-details/employees-details.component';
import { ModalService } from 'mis-crystal-design-system/modal';
import { CommonService } from 'src/app/trip-view/services/common.service';
import { CommonCabService } from 'src/app/trip-view-cab/services/common-cab.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
@Component({
  selector: 'app-attendance-cab',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceCabComponent implements OnInit {
  imgSrc: string;
  plannedBoarding: number;
  spareSeats: number;
  constructor(private testPopup: ModalService, private commonCabService: CommonCabService, private envService: EnvironmentService) { }
  initialState = {}
  attendance: any = {}
  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
    
    this.commonCabService.attendance$.subscribe((data) => {
      // this.plannedBoarding = this.attendance.plannedemployeesBoarded;
      this.attendance = data;
      console.log('attendance', this.attendance);
      if (!this.attendance.totalCapacity) {
        this.attendance.totalCapacity = 0;
        this.spareSeats = 0;
        this.attendance.totalPlannedEmployeesToBoard = this.attendance.plannedemployeesBoarded;
        this.attendance.plannedemployeesBoarded = 0;
      }
      else {
        this.spareSeats = this.attendance.totalCapacity - this.attendance.totalPlannedEmployeesToBoard - this.attendance.plannedemployeesBoarded;
      }
    })
  }
  openModal() {
    this.testPopup.show(EmployeesDetailsComponent, { closeOnBackdropClick: true });
    this.commonCabService.sendEvent("Attendance Report Opened", "mis_modern_trip_view", "attendance_report", "Yes",this.commonCabService.buid, new Date().toISOString().split('T')[0]);
  }

}
